module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userinfo"
  }, [_c('mu-appbar', {
    staticClass: "title",
    attrs: {
      "title": "登录"
    }
  }), _vm._v(" "), (!_vm.userInfo.loginname) ? _c('main', [_c('mu-text-field', {
    attrs: {
      "label": "Access Token",
      "errorText": _vm.error,
      "labelFloat": ""
    },
    model: {
      value: (_vm.accesstoken),
      callback: function($$v) {
        _vm.accesstoken = $$v
      },
      expression: "accesstoken"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "label": "登录",
      "primary": ""
    },
    on: {
      "click": _vm.login
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.loginname) ? _c('div', {
    staticClass: "content"
  }, [_c('input', {
    staticClass: "logout",
    attrs: {
      "title": "退出",
      "type": "button",
      "value": "退出"
    },
    on: {
      "click": _vm.logout
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fistContent"
  }, [_c('div', {
    staticClass: "avator"
  }, [_c('img', {
    attrs: {
      "title": _vm.userInfo.loginname,
      "src": _vm.userInfo.avatar_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "userdetail"
  }, [_c('h3', [_vm._v(_vm._s(_vm.userContent.loginname))]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "iconfont icon-github fa-2x"
  }), _vm._v(" ：" + _vm._s(_vm.userContent.githubUsername))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("创建时间：" + _vm._s(_vm._f("formatDate")(_vm.userContent.create_at)))]), _vm._v("\n              \n            "), _c('span', [_vm._v("积分：" + _vm._s(_vm.userContent.score))])])])]), _vm._v(" "), _c('div', {
    staticClass: "secondContent"
  }, [_c('mu-tabs', {
    staticClass: "activeTab",
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "chuangjian",
      "title": "最近创建的话题"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "canyu",
      "title": "最近参与的话题"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "shoucang",
      "title": "收藏的话题"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "othertopic"
  }, [(_vm.articleItems.length !== 0) ? _vm._l((_vm.articleItems), function(article, index) {
    return _c('div', {
      key: index,
      staticClass: "article"
    }, [_c('div', {
      staticClass: "articleAvator"
    }, [_c('img', {
      attrs: {
        "title": article.author.loginname,
        "src": article.author.avatar_url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "articleTitle"
    }, [_c('p', [_vm._v(_vm._s(article.author.loginname)), _c('i', [_vm._v(_vm._s(_vm._f("formatDate")(article.last_reply_at)) + "更新")])]), _vm._v(" "), _c('h2', [_c('router-link', {
      attrs: {
        "to": {
          path: 'detail',
          query: {
            id: article.id
          }
        },
        "title": article.title
      }
    }, [_vm._v(_vm._s(article.title))])], 1)])])
  }) : _vm._e(), _vm._v(" "), (_vm.articleItems.length === 0) ? _c('div', {
    staticClass: "userTips"
  }, [_c('h2', [_vm._v("暂无内容哦。。。🙃")])]) : _vm._e()], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('mfooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7137f336","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Userinfo.vue
// module id = 159
// module chunks = 2